import { render, staticRenderFns } from "./Action-estoque.vue?vue&type=template&id=784d3ef2&scoped=true&"
import script from "./Action-estoque.vue?vue&type=script&lang=js&"
export * from "./Action-estoque.vue?vue&type=script&lang=js&"
import style0 from "./Action-estoque.vue?vue&type=style&index=0&id=784d3ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d3ef2",
  null
  
)

export default component.exports